"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWindow;
function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/query/isWindow.js
// module id = 4878
// module chunks = 39